import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { GridPaginationListViewModelImpl } from "../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel";
import { FlashMessageCardCSSStyle, FlashMessageCardCSSStyleImpl } from "./flashmessagecard/flashmessagecardcss";
import { FlashMessageCardComponent } from "./flashmessagecard/flashmessagecardcomponent";
import * as React from "react";
import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { FlashMessageEvenCardCSSStyle, FlashMessageEvenCardCSSStyleImpl } from "./flashmessagecard/flashmessageevencardcss";


export class FlashMessageListViewModelImpl extends GridPaginationListViewModelImpl<FlashMessageDto>
{
    protected toneOddCardCSSStyle: FlashMessageCardCSSStyle;
    protected toneEvenCardCSSStyle : FlashMessageEvenCardCSSStyle;
 
    constructor(offset: string, context: BaseContext,title: string, private onSetNow: any)
    {
        super(offset,context);
        this.toneOddCardCSSStyle = new FlashMessageCardCSSStyleImpl(context);

        this.toneEvenCardCSSStyle = new FlashMessageEvenCardCSSStyleImpl(context);
    }

    getView(t: FlashMessageDto, position: number): boolean | JSX.Element 
    {   
        if(position % 2 === 0)
        {
           return <FlashMessageCardComponent onSetNow={this.onSetNow} cardStyle={this.toneEvenCardCSSStyle} key={position}  context={this.getContext()} flashMessageDto={t}  position={position}/>;  
        }
        else{
            return <FlashMessageCardComponent onSetNow={this.onSetNow} cardStyle={this.toneOddCardCSSStyle} key={position}  context={this.getContext()} flashMessageDto={t}  position={position}/>;  

        }
    }
 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagelistviewmodel.tsx